import { create } from 'zustand';

/**
 * FRONT-3077: whether the person pressed the header's "New" and the window
 * shows the "New app" view over the bound app. The header sets it, the body
 * reads it, and a successful bind clears it (`useBindProBuilderApp`).
 * Unmounting the terminal for the view and remounting it on Cancel does not
 * bump the terminal key, so the same shell is reattached.
 */
interface ProBuilderPickerStore {
  creating: boolean;
  setCreating: (creating: boolean) => void;
}

export const useProBuilderPickerStore = create<ProBuilderPickerStore>((set) => ({
  creating: false,
  setCreating: (creating) => set({ creating }),
}));
